import styles from './FJAccountList.module.less';
import FJLocalStore from '@src/store/FJLocalStore';
import FJAccountItem from '@src/components/FJModals/FJShareModal/FJAccount/FJAccountItem.tsx';
import AddIcon from '../../../../assets/add.svg?react';
import { type SOCIAL_ITEM, SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';

interface Props {
    list: SOCIAL_ITEM[];
    selectedShareTypes: string[];
    publishedTypes: string[];
    failedTypes: string[];
    addAccount?: () => void;
    onSelect?: (shareType: string) => void;
    linkedinError?: string;
}

const FJAccountList = ({
    list,
    selectedShareTypes,
    publishedTypes,
    failedTypes,
    addAccount,
    onSelect,
    linkedinError,
}: Props) => {
    return (
        <div className={styles.box}>
            <div className={styles.content}>
                <p className={styles.header}>{FJLocalStore._('share-to-social')}</p>
                <div className={styles.list}>
                    {list.map(item => {
                        const { shareType, avatar, email } = item;
                        const isPublished = publishedTypes.includes(shareType);
                        const isSelected = selectedShareTypes.includes(shareType);
                        const isFailed = failedTypes.includes(shareType);
                        const isShowErrorTips = shareType === SOCIAL_KEY.LINKEDIN && !!linkedinError;
                        return (
                            <FJAccountItem
                                key={shareType}
                                isSelected={isSelected}
                                isPublished={isPublished}
                                isFailed={isFailed}
                                platform={shareType}
                                avatarUrl={avatar}
                                email={email}
                                onClick={onSelect}
                                isShowErrorTips={isShowErrorTips}
                            />
                        );
                    })}
                </div>
                {addAccount && (
                    <div className={styles.add_account_box} onClick={addAccount}>
                        <div className={styles.add_account_gradient}>
                            <div className={styles.add_account_btn}>
                                <AddIcon />
                                <p>{FJLocalStore._('add-account')}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FJAccountList;
